export const API_HOSTNAME = process.env['REACT_APP_API_URL'];

export const API_ERROR = 'Wystąpił błąd. Spróbuj ponownie.';

export const MAIN_TITLE = 'Karta uczestnika';
export const MAIN_DESCRIPTION = {
    1: 'Wypełnij poniższy formularz, aby móc wprowadzić wyniki testu oraz pobrać raporty.',
    2: 'Dotyczy płatnych programów:\u00A0',
    3: 'Lupa 1',
    4: ',\u00A0',
    5: 'Lupa 3',
    6: ',\u00A0',
    7: 'Próbny egzamin w 7 klasie',
    8:  ',\u00A0',
    9:  'Próbny egzamin ósmoklasisty',
    10: '\u00A0oraz\u00A0',
    11: 'Próbna matura',
    12: '.',
};

export const FORM_SUBMIT = 'Wyślij';
export const FORM_VALIDATION = 'Błędnie wypełniony formularz';
export const FORM_SUCCESS = {
    1: 'Dziękujemy, pod podanym adresem e-mail wysłaliśmy instrukcję.',
    2: 'Można ją pobrać również',
};

export const REQUIRED = '* - Pola wymagane.';

export const PERSONAL_TITLE = 'Moje dane';
export const PERSONAL_FIRSTNAME = 'Imię';
export const PERSONAL_LASTNAME = 'Nazwisko';
export const PERSONAL_EMAIL = 'Adres e-mail';
export const PERSONAL_EMAIL_DESCRIPTION = 'Prywatny adres e-mail lub imienny służbowy adres e-mail';
export const PERSONAL_PHONE = 'Numer telefonu komórkowego';

export const SCHOOL_TITLE = 'Moja szkoła';
export const SCHOOL_CHANGE_BUTTON = 'Zmień szkołę';
export const SCHOOL_SELECT_BUTTON = 'Wybierz szkołę';
export const SCHOOL_DESCRIPTION = {
    1: 'Jeżeli na liście nie ma Twojej szkoły, wypełnij\u00A0',
    2: 'interaktywny formularz (plik PDF)',
    3: '.',
    4: 'Uwaga: aby móc wypełnić formularz należy otworzyć go w programie Adobe Acrobat Reader.',
    5: 'Wypełnioną kartę prosimy wysłać pod adresem e-mailowym\u00A0',
    6: '.',
};
export const SCHOOL_EMAIL = 'dokumenty@gwo.pl';

export const SCHOOL_MODAL_TITLE = 'Wybierz szkołę';
export const SCHOOL_MODAL_CITY = 'Podaj miasto';
export const SCHOOL_MODAL_STREET = 'Podaj ulicę (bez numeru budynku)';
export const SCHOOL_MODAL_ZIP = 'Podaj kod pocztowy';
export const SCHOOL_MODAL_SUBMIT_BUTTON = 'Szukaj';
export const SCHOOL_MODAL_DESCRIPTION = 'Jeżeli nie znajdujesz swojej szkoły, spróbuj ograniczyć kryteria wyszukiwania, np. wpisz tylko kod pocztowy.';
export const SCHOOL_MODAL_SELECT_BUTTON = 'Wybierz';
export const SCHOOL_MODAL_PAGE = 'strona';

export const PROGRAMS_TITLE = 'Programy';
export const PROGRAMS_DESCRIPTION = 'Aby wybrać program, najpierw wybierz szkołę.';

export const SUBJECTS_TITLE = 'Przedmioty';
export const SUBJECTS_DESCRIPTION = 'Aby wybrać przedmiot, w pierwszej kolejności wybierz szkołę i program.';

export const TERMS_SELECT_ALL = 'Zaznacz wszystkie zgody';
export const TERMS_DESCRIPTION = 'Zaznacz poniższe zgody, aby móc wprowadzić wyniki testu oraz pobrać raporty.';
export const TERMS_MARKETING = '* Wyrażam zgodę na przetwarzanie danych osobowych wskazanych w formularzu przez współadministratorów danych: Gdańskie Wydawnictwo Oświatowe spółka z ograniczoną odpowiedzialnością sp. k., al. Grunwaldzka 50A, 80-241 Gdańsk („GWO”) oraz Instytut Rozwoju Edukacji – Fundację im. Adama Mysiora, al. Grunwaldzka 50A, 80-241 Gdańsk („IRE”) w celach marketingowych, w szczególności w celu przesyłania mi informacji o produktach i ofertach współadministratorów oraz prowadzenia działań reklamowych w serwisach społecznościowych, w tym poprzez kierowanie przekazu do wybranych grup odbiorców oraz zapraszanie do grup tematycznych.';
export const TERMS_EMAIL = '* Wyrażam zgodę na przesyłanie mi informacji handlowych i na wykorzystanie w tym celu urządzeń używanych przeze mnie do komunikacji (m.in. telefonu, tabletu, komputera).';
export const TERMS_CALL = 'Wyrażam zgodę na kontakt telefoniczny na potrzeby marketingu bezpośredniego m. in. w związku z ofertą handlową współadministratorów i na wykorzystanie w tym celu urządzeń używanych przeze mnie do komunikacji (m.in. telefonu, tabletu).';
export const TERMS_PERSONAL = 'Informacje o przetwarzaniu danych osobowych (kliknij)';
export const TERMS_INFO = [
    `Dane osobowe będą przetwarzane przez współadministratorów na podstawie art. 6 ust. 1 lit. a) RODO. Podanie danych osobowych jest dobrowolne. Niepodanie danych uniemożliwi ich przetwarzanie, w tym przesyłanie informacji o produktach i ofertach współadministratorów (GWO lub IRE) oraz wprowadzenie wyników testów i wygenerowanie raportów. Dane będą przetwarzane do czasu wycofania zgody. Dane mogą być profilowane w oparciu o kryteria takie jak nauczany przedmiot, w celu dopasowania ofert i rabatów do potrzeb klientów. Dane będą przetwarzane również na podstawie art. 6 ust. 1 lit. b) RODO w celu realizacji usługi, której dotyczy formularz, do czasu zakończenia jej realizacji, a także na podstawie art. 6 ust. 1 lit. f) RODO w celu ustalenia, dochodzenia lub obrony roszczeń, do czasu przedawnienia roszczeń. `,

    `Odbiorcami danych mogą być podmioty świadczące na rzecz GWO lub IRE usługi informatyczne, marketingowe, doradcze, związane z obsługą baz danych lub prowadzeniem serwisów społecznościowych, a także podmioty uprawnione do uzyskania danych na podstawie przepisów prawa. W przypadku przekazywania danych poza Europejski Obszar Gospodarczy współadministratorzy zapewnią odpowiedni stopień ochrony danych, w szczególności na podstawie decyzji Komisji Europejskiej stwierdzającej odpowiedni stopień ochrony albo standardowych klauzul umownych.`,

    `Masz prawo dostępu do danych, do ich sprostowania, usunięcia, przeniesienia, ograniczenia przetwarzania, do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem oraz do wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych. Masz prawo w dowolnym momencie wnieść sprzeciw wobec przetwarzania danych z przyczyn związanych z Twoją szczególną sytuacją. Możesz realizować swoje uprawnienia względem każdego ze współadministratorów z osobna, pisząc pod adresem:`,
];
export const TERMS_GWO_EMAIL = 'dane.osobowe@gwo.pl';
export const TERMS_MARK = '\u2013\u00A0';
export const TERMS_GWO_DESCRIPTION = '\u00A0\u2013 w związku z przetwarzaniem danych przez GWO';
export const TERMS_IRE_EMAIL = 'dane.osobowe@ire.edu.pl';
export const TERMS_IRE_DESCRIPTION = '\u00A0\u2013 w związku z przetwarzaniem danych przez IRE.';
export const TERMS_ADMINS = 'Współadministratorzy danych zastrzegają sobie prawo do weryfikacji poprawności podanych danych.';

export const COOKIES_TITLE = 'Polityka wykorzystania plików Cookies';
export const COOKIES_INFO = [
    {
        id: 1,
        paragraph: 'Serwis nie zbiera w sposób automatyczny żadnych informacji, z wyjątkiem informacji zawartych w plikach cookies.',
    },
    {
        id: 2,
        paragraph: 'Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu. Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.',
    },
    {
        id: 3,
        paragraph: 'Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu GWO.PL Gdańskie Wydawnictwo Oświatowe spółka z ograniczoną odpowiedzialnością spółka komandytowa z siedzibą pod adresem: Gdańsk, ul. Grunwaldzka 413.',
    },
    {
        id: 4,
        paragraph: 'Pliki cookies wykorzystywane są w celu:',
        paragraphs: [
            {
                id: 5,
                paragraph: 'dostosowania zawartości stron internetowych Serwisu do preferencji Użytkownika oraz optymalizacji korzystania ze stron internetowych; w szczególności pliki te pozwalają rozpoznać urządzenie Użytkownika Serwisu i odpowiednio wyświetlić stronę internetową, dostosowaną do jego indywidualnych potrzeb;'
            }, {
                id: 6,
                paragraph: 'tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron internetowych, co umożliwia ulepszanie ich struktury i zawartości;'
            }, {
                id: 7,
                paragraph: 'utrzymanie sesji Użytkownika Serwisu (po zalogowaniu), dzięki której Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;'
            },
        ]
    },
    {
        id: 8,
        paragraph: 'W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies) oraz „stałe” (persistent cookies). Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania (przeglądarki internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.',
    },
    {
        id: 9,
        paragraph: 'W ramach Serwisu stosowane są następujące rodzaje plików cookies:',
        paragraphs: [
            {
                id: 10,
                paragraph: '„niezbędne” pliki cookies, umożliwiające korzystanie z usług dostępnych w ramach Serwisu, np. uwierzytelniające pliki cookies wykorzystywane do usług wymagających uwierzytelniania w ramach Serwisu;'
            }, {
                id: 11,
                paragraph: 'pliki cookies służące do zapewnienia bezpieczeństwa, np. wykorzystywane do wykrywania nadużyć w zakresie uwierzytelniania w ramach Serwisu;'
            }, {
                id: 12,
                paragraph: '„funkcjonalne” pliki cookies, umożliwiające „zapamiętanie” wybranych przez Użytkownika ustawień i personalizację interfejsu Użytkownika, np. w zakresie wybranego języka lub regionu, z którego pochodzi Użytkownik, rozmiaru czcionki, wyglądu strony internetowej itp.;'
            },
        ]
    },
    {
        id: 13,
        paragraph: 'W wielu przypadkach oprogramowanie służące do przeglądania stron internetowych (przeglądarka internetowa) domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać w każdym czasie zmiany ustawień dotyczących plików cookies. Ustawienia te mogą zostać zmienione w szczególności w taki sposób, aby blokować automatyczną obsługę plików cookies w ustawieniach przeglądarki internetowej bądź informować o ich każdorazowym zamieszczeniu w urządzeniu Użytkownika Serwisu. Szczegółowe informacje o możliwości i sposobach obsługi plików cookies dostępne są w ustawieniach oprogramowania (przeglądarki internetowej).',
    },
    {
        id: 14,
        paragraph: 'Operator Serwisu informuje, że ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu.',
    },
    {
        id: 15,
        paragraph: 'Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu i wykorzystywane mogą być również przez współpracujących z operatorem Serwisu reklamodawców oraz partnerów.',
    },
];

export const RODO_LINK = 'RODO';
export const RODO_URL = 'https://gwo.pl/rodo/';

export const FOOTER_LINKS = [
    {
        label: 'POLECANE STRONY',
        active: true,
        links: [
            {
                label: 'Akademia GWO',
                url: 'https://akademia.gwo.pl/'
            },
            {
                label: 'Blog GWO',
                url: 'https://blog.gwo.pl/',
            },
            {
                label: 'Labirynt wiedzy',
                url: 'https://labiryntywiedzy.gwo.pl/',
            },
            {
                label: 'Programy komputerowe GWO',
                url: 'https://pakietyszkolne.gwo.pl/',
            },
        ],
    },

    {
        label: 'O NAS',
        active: true,
        links: [
            {
                label: 'Historia GWO',
                url: 'https://gwo.pl/historia-gwo/'
            },
            {
                label: 'Kodeks Dobrych Praktyk',
                url: 'https://gwo.pl/kodeks-dobrych-praktyk/',
            },
            {
                label: 'Napisali o nas',
                url: 'https://gwo.pl/napisali-o-nas/',
            },
            {
                label: 'Projekty UE',
                url: 'https://gwo.pl/projekty-ue/',
            },
            {
                label: 'Regulaminy i licencje',
                url: 'https://gwo.pl/regulaminy/',
            },
        ],
    },

    {
        label: 'WSPÓŁPRACA Z GWO',
        active: true,
        links: [
            {
                label: 'Zostań autorem',
                url: 'https://gwo.pl/zostan-autorem/',
            },
            {
                label: 'Praca',
                url: 'https://gwo.pl/praca/',
            },
            {
                label: 'Dla księgarni i hurtowni',
                url: 'https://hurt.gwo.pl/',
            },
        ],
    },

    {
        label: 'FACEBOOK',
        active: true,
        links: [
            {
                label: 'Gdańskie Wydawnictwo Oświatowe',
                url: 'https://pl-pl.facebook.com/GdanskieWydawnictwoOswiatowe',
            },
            {
                label: 'Matlandia',
                url: 'https://www.facebook.com/Matlandia',
            },
        ],
    },

    {
        label: 'KONTAKT',
        active: true,
        links: [
            {
                label: 'Skontaktuj się z nami',
                url: 'https://gwo.pl/skontaktuj-sie-z-nami/',
            },
            {
                label: 'Przedstawiciele regionalni',
                url: 'https://gwo.pl/przedstawiciele-regionalni/',
            },
            {
                label: 'Pomoc',
                url: 'https://gwo.pl/skontaktuj-sie-z-nami/',
            },
        ],
    }
];
export const FOOTER_COPYRIGHT = `Copyright \u00A9 by Gdańskie Wydawnictwo Oświatowe \u2013 ${new Date().getFullYear()}`;
export const FOOTER_COOKIES_TEXT = `Ta strona używa plików cookies.\u00A0`;
export const FOOTER_COOKIES_LINK = 'Dowiedz się więcej';
